<template>
    <div>
        <div id="main"></div>
    </div>
</template>

<script>
import * as echarts from "echarts";
export default {
    props: ["data"],
    data() {
        return {
            all_months: [
                this.$t("statistics.january"),
                this.$t("statistics.february"),
                this.$t("statistics.march"),
                this.$t("statistics.april"),
                this.$t("statistics.may"),
                this.$t("statistics.june"),
                this.$t("statistics.july"),
                this.$t("statistics.august"),
                this.$t("statistics.september"),
                this.$t("statistics.october"),
                this.$t("statistics.november"),
                this.$t("statistics.december"),
            ],
            myChart: null,
        };
    },
    mounted() {
        this.setChart();
        setTimeout(() => {
            if (this.myChart) {
                this.myChart.resize();
            }
        }, 2000);
    },
    methods: {
        setChart() {
            this.myChart = echarts.init(document.getElementById("main"));
            const items = Array.isArray(this.data) ? this.data : Object.values(this.data || {});
            const priceFmt = (v) => `${this.formatPrice(v)} €`;
            const axisPriceFmt = (v) => (Number(v) === 0 ? '' : priceFmt(v));
            var options = {
                tooltip: {
                    trigger: 'axis',
                    valueFormatter: priceFmt
                },
                legend: {
                    data: items.map(item => item.name),
                    
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.labels()
                },
                yAxis: {
                    type: 'value',
                    min: 0,
                    splitNumber: 8,
                    axisLabel: {
                        formatter: axisPriceFmt
                    }
                },
                series: items.map(item => ({
                    name: item.name,
                    type: 'line',
                    data: item.data,
                    color: item.color
                }))
            };
            this.myChart.setOption(options);
            window.addEventListener("resize", this.myChart.resize);
        },
        formatPrice(value) {
            let val = (value / 1).toFixed(0).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        labels() {
            var labels = [];
            var today = new Date();
            for (var i = 5; i >= 0; i -= 1) {
                var d = new Date(today.getFullYear(), today.getMonth() - i, 1);
                labels.push(
                    (d.getMonth() + 1).toString() +
                    "/" +
                    d.getFullYear().toString()
                );
            }
            return labels;
        },
    },
};
</script>

<style lang="scss" scoped>
h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #212541;
}

#main {
    width: 100%;
    height: 420px;

    @media (max-width: 1600px) {
        height: 350px;
    }

    @media (max-width: 1400px) {
        height: 320px;
    }

    @media (max-width: 1200px) {
        height: 300px;
    }
}
</style>
